document.addEventListener('DOMContentLoaded', (event) => {
  ;(function (d, tid, vid) {
    if (typeof _ltk != 'undefined') return
    var js = d.createElement('script')
    js.id = 'ltkSDK'
    js.src =
      'https://cdn.listrakbi.com/scripts/script.js?m=' + tid + '&v=' + vid
    d.querySelector('head').appendChild(js)
  })(document, window.listrak.merchantId, '1')
  ;(function () {
    if (typeof _ltk == 'object') {
      ltkCode()
    } else {
      ;(function (d) {
        if (document.addEventListener) {
          document.addEventListener('ltkAsyncListener', d)
        } else {
          e = document.documentElement
          e.ltkAsyncProperty = 0
          e.attachEvent('onpropertychange', function (e) {
            if (e.propertyName == 'ltkAsyncProperty') {
              d()
            }
          })
        }
      })(function () {
        ltkCode()
      })
    }

    function ltkCode() {
      _ltk_util.ready(function () {
        const inputEmail = document.querySelector('.js-newsletter-email-input')
        const submitEmailButton = document.querySelector(
          '.js-newsletter-submit'
        )

        const emailErrorMessage = document.querySelector('.js-newsletter-error')
        const statusMessageContainer = document.querySelector(
          '.js-newsletter-status'
        )

        let waitingEmailSubmit = false
        let emailSuccess = false

        const displayFormSuccessMessage = () => {
          emailSuccess = true
          inputEmail.value = ''
          inputEmail.setAttribute('disabled', '')
          submitEmailButton.classList.add('hidden')
          emailErrorMessage.classList.add('hidden')
          statusMessageContainer.textContent = inputEmail.getAttribute(
            'data-confirmation-message'
          )
        }

        function timeoutEnded() {
          waitingEmailSubmit = false
          if (!emailSuccess) emailErrorMessage.classList.remove('hidden')
        }

        function submitClicked() {
          if (waitingEmailSubmit) return
          emailErrorMessage.classList.add('hidden')
          emailSuccess = false
          waitingEmailSubmit = true
          setTimeout(
            function (timeoutEnded) {
              timeoutEnded('email')
            },
            1000,
            timeoutEnded
          )
        }

        submitEmailButton.addEventListener('click', () => {
          submitClicked('email')
        })

        document.addEventListener('ltkSubscribe', (e) => {
          if (e.detail.list == window.listrak.listId)
            displayFormSuccessMessage('email')
        })

        _ltk.Signup.New(
          window.listrak.listId,
          'FooterNewsletterEmail',
          _ltk.Signup.TYPE.CLICK,
          'FooterNewsletterSubmit',
          'email'
        )
      })
    }
  })()
})
